import XMarkSolid from '../../icons/solid/x-mark-solid';

const PopoverHeader = ({ title, onClose }: { title: string; onClose: () => void }): JSX.Element => {
    return (
        <div className="rounded-t-8 py-8 px-16 flex flex-row justify-between items-center border-b-1 border-darwin-neutral-100">
            <div className="text-14 font-700">{title}</div>
            <button className="text-darwin-neutral-1000" onClick={onClose}>
                <XMarkSolid className="w-12 h-12" />
            </button>
        </div>
    );
};

export default PopoverHeader;
